import { ReactNode, useId } from "react";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import chip from "../Chip/Chip.module.scss";
import s from "./ToggleSection.module.scss";

type Props = { label: ReactNode; pressed: boolean; onToggle: () => void; children: ReactNode };

/**
 * A chip that opens a section under it ("Remind me", "Update contact details"): the kit chip's look, a disclosure's ARIA
 * (aria-expanded + aria-controls, not aria-pressed). The section is in the page only while open.
 */
export const ToggleSection = ({ label, pressed, onToggle, children }: Props) => {
  const id = useId();
  const panel = `${id}-panel`;
  return (
    <div className={s.section}>
      <button type="button" aria-expanded={pressed} aria-controls={panel} onClick={onToggle}
        className={[chip.chip, chip.tap, pressed ? chip.on : "", s.toggle].filter(Boolean).join(" ")}>
        <span>{label}</span>
        <span aria-hidden className={`${chip.icon} ${pressed ? `${s.chevron} ${s.open}` : s.chevron}`}><ExpandMoreRoundedIcon /></span>
      </button>
      {pressed && <div id={panel} className={s.panel}>{children}</div>}
    </div>
  );
};
